
/**
 * Module dependencies.
 */

import {
  authRequest,
  handleRequestError
} from 'src/core/utils/requests';

import { getAuthApiEndpoint } from 'src/core/utils/api-url-resolver';

/**
 * `Query` type.
 */

type Query = {
  email: string,
  password: string
};

/**
 * Export `createToken`.
 */

export async function createToken({ email, password }: Query) {
  const endpoint = getAuthApiEndpoint('createToken');

  try {
    const { data } = await authRequest.post(endpoint, { email, password });

    return data?.data;
  } catch (error) {
    throw handleRequestError(error);
  }
}
